import { useState } from "react";
import { PhoneInput } from "./PhoneInput";

export const NameStep = ({ onSave }) => {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState({ raw: "", e164: "", valid: true, region: "NZ" });
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (phone.raw && !phone.valid) return setError("That phone number doesn't look valid.");
    setBusy(true); setError("");
    try { await onSave(name.trim(), phone.e164 || null); } catch (err) { setError(err.message); }
    setBusy(false);
  };

  return (
    <section className="card fade-up" data-testid="name-step">
      <p className="eyebrow">One last thing</p>
      <h2 className="card-title">What's your name?</h2>
      <p className="text-sm text-muted mt-2">Contractors will see “Dispatched by [your name]” and can call you back.</p>
      <form onSubmit={submit} className="flex flex-col gap-3 mt-4">
        <input data-testid="name-input" className="field" placeholder="e.g. Dave Henderson" value={name} onChange={(e) => setName(e.target.value)} required minLength={2} autoFocus />
        <PhoneInput value={phone.raw} onChange={setPhone} placeholder="Phone (optional)" testid="name-phone" />
        {error && <p role="alert" data-testid="name-error" className="text-sm text-[#FF7A7A]">{error}</p>}
        <button data-testid="name-save-button" className="btn-primary" disabled={busy || name.trim().length < 2}>{busy ? "Saving…" : "Save & continue"}</button>
      </form>
    </section>
  );
};
